import * as React from 'react';
import { Dispatch, Action } from 'redux';
import { ItemList } from '../common/ItemList';
import SettingPopup from '../common/SettingPopup';
import { setUserName } from '../../actions/PreferenceAction';
import { createDateTimeString } from '../../utils/string';
import { Publication } from '../../types/epub';
import { findItemByBookmarkReference } from '../../reducers/pages';

// TODO ItemListとコード共通化
interface ReferenceLevelProps {
  reference: string;
  title: string;
  bookmarks: BookmarkItem[];
  onClick: (reference: string) => void;
  onClickItem: (item: BookmarkItem, index: number) => void;
  onClickDeleteItem: (item: BookmarkItem, index: number) => void;
}

class ReferenceLevel extends React.PureComponent<ReferenceLevelProps> {
  public render() {
    const createListRowItem = (item: BookmarkItem) => {
      return <div style={item.isImported ? { color: 'red' } : {}}><div style={{ flex: 1 }}>
          <span>{item.title}</span>{' / '}
          <span>{item.createdBy}</span>{' / '}
          <span>{createDateTimeString(new Date(item.createdAt))}</span>
        </div>
      </div>;
    };

    const itemStyle: React.CSSProperties = {
      ...ItemList.defaultProps.itemStyle,
      fontSize: '0.9em',
      padding: '2px 16px',
      borderBottom: 'none',
      borderTop: '1px solid #aaa',
      background: 'rgb(249, 248, 244)',
    };

    return (
      <div style={{ borderBottom: '1px solid #aaa', background: '#ddd' }}>
        <div style={{ padding: '0 5px' }}>
          <a href="javascript:void(0)"
            style={{ display: 'inline-block', width: '1.5em', height: '1.5em', color: 'inherit' }}
            title="TODO: 折り畳み">▼</a>
          <a href="javascript:void(0)"
            style={{ color: 'inherit' }}
            onClick={() => this.props.onClick(this.props.reference)}>
            {this.props.title}
          </a>
          <span>&nbsp;({this.props.bookmarks.length})</span>
        </div>
        <ItemList
          items={this.props.bookmarks}
          onClick={this.props.onClickItem}
          onClickDelete={this.props.onClickDeleteItem}
          createListRowItem={createListRowItem}
          itemStyle={itemStyle}
          containerStyle={{ width: 'auto' }}/>
      </div>
    );
  }
}

export interface BookmarkItem {
  readonly id: string;
  readonly createdAt: string;
  readonly reference: string;
  readonly title: string;
  readonly createdBy: string;
  readonly isImported: boolean;
}

export interface BookmarkItemListPopupProps {
  items: ReadonlyArray<BookmarkItem>;
  onClickReference: (reference: string) => void;
  onClickItem: (item: BookmarkItem, index: number) => void;
  onClickDeleteItem: (item: BookmarkItem, index: number) => void;
  userName?: string;
  isOpen: boolean;
  dispatch: Dispatch<Action>;
  onClose: () => void;
  publication: Publication;
}

export class BookmarkItemListPopup extends React.PureComponent<BookmarkItemListPopupProps> {
  private headerStyle: Readonly<React.CSSProperties> = {
    padding: '8px 16px',
    borderBottom: '1px solid #aaa',
  };

  private bodyStyle: Readonly<React.CSSProperties> = {
    width: '500px',
    height: '400px',
    boxSizing: 'border-box',
    overflow: 'auto',
    background: 'rgb(249, 248, 244)',
  };

  private createHeader() {
    return <div style={this.headerStyle}>{'なまえ：'}
      <input
        type="text"
        defaultValue={this.props.userName}
        onChange={(ev) => {
          if (ev.target.value) {
            this.props.dispatch(setUserName(ev.target.value));
          }
        }} />
    </div>;
  }

  private createList() {
    const { publication } = this.props;

    const pages: { [reference: string]: BookmarkItem[] } = {};
    this.props.items.forEach((item) => {
      const items = pages[item.reference] || [];
      pages[item.reference] = [...items, item];
    });

    return Object.keys(pages).map(reference => <ReferenceLevel
      key={reference}
      reference={reference}
      title={(findItemByBookmarkReference(reference, publication) || { title: '-' }).title}
      bookmarks={pages[reference]}
      onClick={this.props.onClickReference}
      onClickItem={this.props.onClickItem}
      onClickDeleteItem={this.props.onClickDeleteItem}
    />);
  }

  private createFooter() {
    return <div>{/* TODO */}</div>;
  }

  public render() {
    if (!this.props.isOpen) {
      return null;
    }

    return (
      <SettingPopup title={'しおり一覧'} onClose={this.props.onClose}>
        <div style={this.bodyStyle}>
          {this.createHeader()}
          {this.createList()}
          {this.createFooter()}
        </div>
      </SettingPopup>
    );
  }
}
